module.exports = __webpack_public_path__ + "img/caf1b91.png";